import React from "react";
import {connect} from "react-redux";
import queryString from "query-string";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Card, Col, Container, Modal, Row} from "react-bootstrap";
import {productoActions, utilActions} from "../../../_actions";
import {ErrorMessage, history, LoadingBoton, TIPO_IMAGEN} from "../../../_helpers";
import {NavBarLateral} from "../../includes";
import authService from "../../../_services/cart/authService";
import userServiceTs from "../../../_services/cart/userService";
import http from '../../../_services/cart/http.service';
import alertService from "../../../_services/cart/alert.service";
import ReactSwitch from "react-switch";
import { Formik, Form, Field, FieldArray } from "formik";
import { userService } from "../../../_services";
import * as Yup from "yup";
import MiUploadArchivo from "../../../_helpers/MiUploadArchivo";
import Select from "react-select";
import vendedorService from "../../../_services/cart/vendedor.service";

const _ = require("lodash");

class FormEditarPerfil extends React.Component {

    state = {
        showMp: false,
        grabando: false,
        provincias: []
    }

    componentDidMount() {
        vendedorService.getProvincias(this.setProvincias);
    }

    setProvincias = (provincias) => {
        this.setState({ provincias: provincias });
    };

    render() {

        const {usuario, show, handleClosePerfil} = this.props;
        let esVendedor = usuario.esVendedor;

        const customSelect = {
            control: (provided) => ({
                // class attribute : class=" css-i32vvf-control"
                ...provided,
                background: "transparent",
                display: "flex",
                flexWrap: "nowrap",
                borderColor: "hsl(0deg 0% 80%);",
                width: "100%",
                height: "48px",
            }),
        };

        console.log(usuario)

        let inic = {
            latitud: "",
            longitud: "",
            direccion: "",
            codigoPostal: "",
            ciudad: "",
            imagenes: [],
            provincia: {},
            firstName: "",
            lastName: "",
            email: "",
            numeroCelular: "",
            username: "",
            password: "",
            confpassword: "",
            alias:'',
            cbu:'',
            plantillaDescripcion: ''
            };

        let user = _.clone(usuario);

         inic = utilActions.setearValores(inic, user);

        return (
            <><Modal
                        size="xl"
                        show={show}
                        onHide={handleClosePerfil}
                        backdrop="static"
                    >
                        <Modal.Header className="bg-cielo " closeButton>
                        <Modal.Title>
                            <i className="fas fa-paper-plane"></i> Editar Perfil Usuario
                        </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="th_uva">

                        <Formik
                            enableReinitialize={true}
                            initialValues={inic}
                            onSubmit={(values) => {
                            this.setState({ grabando: true });
                            values.id = usuario.id;
                            userService.editarUsuarioAdmin(values).then(
                                (data) => {
                                    this.setState({ grabando: false });
                                    alertService.msg(
                                        "Perfil de usuario editado exitosamente."
                                    );
                                    handleClosePerfil();
                                },
                                (error) => {
                                    this.setState({ grabando: false });
                                    alertService.error(error);
                                }
                            );
                            }}
                        >
                            {({ errors, touched, values, setFieldValue }) => (

                                <Form>
                                              <div className="dashboard__content-prod">
                                                <div className="form-group">
                                                  <label htmlFor="firstName">Nombre</label>
                                                  <Field className="form-control" name="firstName" />
                                                  <ErrorMessage name={`firstName`} />
                                                </div>
                                                <div className="form-group">
                                                  <label htmlFor="lastName">Apellido</label>
                                                  <Field className="form-control" name="lastName" />
                                                  <ErrorMessage name={`lastName`} />
                                                </div>
                                                <div className="form-group">
                                                  <label htmlFor="telefono">Teléfono Celular</label>
                                                  {/* <InputMask mask="+54 (___) ____-____" replacement={{ _: /\d/ }} onMask={(event) => {
                                                      const { value, input, parts, pattern, isValid } = event.detail;
                                                      console.log(value, input, parts, pattern, isValid)
                                                      setFieldValue('numeroCelular', value)
                                                    }}/> */}
                                                   <Field className="form-control" name="numeroCelular" />
                                                  <ErrorMessage name={`numeroCelular`} />
                                                </div>
                                                <div className="form-group">
                                                  <label htmlFor="email">Mail </label>
                                                  <Field className="form-control" name="email" />
                                                  <ErrorMessage name={`email`} />
                                                </div>
                                                <div className="form-group">
                                                  <label htmlFor="username">Usuario </label>
                                                  <Field className="form-control" name="username" />
                                                  <ErrorMessage name={`username`} />
                                                </div>
                                              </div>
                                
                                
                                
                                             {esVendedor &&
                                             <>
                                              <h4>Datos de pago</h4>
                                              <div className="dashboard__content-prod">
                                                  <div className="form-group">
                                                    <label htmlFor="alias">Alias </label>
                                                    <Field className="form-control" name="alias" />
                                                    <ErrorMessage name={`alias`} />
                                                  </div>
                                                  <div className="form-group">
                                                    <label htmlFor="cbu">CBU </label>
                                                    <Field className="form-control" name="cbu" />
                                                    <ErrorMessage name={`cbu`} />
                                                  </div>
                                              </div>
                                              </>}
                                
                                              <h4>Datos de ubicación</h4>
                                              <div className="dashboard__content-prod">
                                                <div className="form-group">
                                                  <label htmlFor="direccion">Dirección </label>
                                                  <Field className="form-control" name="direccion" />
                                                  <ErrorMessage name={`direccion`} />
                                                </div>
                                                <div className="form-group">
                                                  <label htmlFor="codigoPostal">Codigo Postal </label>
                                                  <Field className="form-control" name="codigoPostal" />
                                                  <ErrorMessage name={`codigoPostal`} />
                                                </div>
                                                <div className="form-group">
                                                  <label htmlFor="ciudad">Ciudad </label>
                                                  <Field className="form-control" name="ciudad" />
                                                  <ErrorMessage name={`ciudad`} />
                                                </div>
                                                <div className="form-group">
                                                  <label htmlFor="provincia">Provincia </label>
                                                  <Select
                                                    styles={customSelect}
                                                    value={
                                                      this.state.provincias
                                                        ? this.state.provincias.find(
                                                            (option) => option.id == values.provincia?.id
                                                          )
                                                        : ""
                                                    }
                                                    getOptionLabel={(option) => `${option.nombre}`}
                                                    getOptionValue={(option) => option.id}
                                                    onChange={(so) => {
                                                      setFieldValue(`provincia`, so);
                                                    }}
                                                    isSearchable={false}
                                                    placeholder="Seleccione una"
                                                    options={this.state.provincias}
                                                  />
                                                  <ErrorMessage name={`provincia`} />
                                                </div>
                                
                                
                                
                                              {esVendedor &&
                                                <>
                                                <div className="form-group">
                                                    <label htmlFor="latitud">Latitud </label>
                                                    <Field className="form-control" name="latitud" />
                                                    <ErrorMessage name={`latitud`} />
                                                  </div>
                                                  <div className="form-group">
                                                    <label htmlFor="longitud">Longitud </label>
                                                    <Field className="form-control" name="longitud" />
                                                    <ErrorMessage name={`longitud`} />
                                                  </div>
                                
                                
                                                </>}
                                              </div>
                                
                                              <h4>Datos de perfil</h4>
                                              <div className="dashboard__content-prod">
                                                <div className="form-group--textarea">
                                                  <div className="textarea-container">
                                                      <label htmlFor="descripcionPerfil">Descripción</label>
                                                      <Field
                                                          as="textarea"
                                                          name="descripcionPerfil"
                                                          rows="4"
                                                          cols="10"
                                                          className="input--outline"
                                                      />
                                                      <ErrorMessage name={`descripcionPerfil`}/>
                                                  </div>
                                                </div>
                                                <div className="form-group--textarea">
                                                  <div className="textarea-container">
                                                      <label htmlFor="plantillaDescripcion">Texto al pie de sus publicaciones</label>
                                                      <Field
                                                          as="textarea"
                                                          name="plantillaDescripcion"
                                                          rows="8"
                                                          cols="10"
                                                          className="input--outline"
                                                      />
                                                      <ErrorMessage name={`plantillaDescripcion`}/>
                                                  </div>
                                                </div>
                                            </div>
                                
                                            <h4>Redes sociales</h4>
                                            <div className="dashboard__content-prod">
                                            <div className="form-group">
                                                    <label htmlFor="linkFacebook">Pagina Facebook </label>
                                                    <Field className="form-control" name="linkFacebook" />
                                                    <ErrorMessage name={`linkFacebook`} />
                                                  </div>
                                
                                                  <div className="form-group">
                                                    <label htmlFor="linkInstagram">Pagina Instagram </label>
                                                    <Field className="form-control" name="linkInstagram" />
                                                    <ErrorMessage name={`linkInstagram`} />
                                                  </div>
                                
                                                  <div className="form-group">
                                                    <label htmlFor="linkWeb">Pagina Web </label>
                                                    <Field className="form-control" name="linkWeb" />
                                                    <ErrorMessage name={`linkWeb`} />
                                                  </div>
                                            </div>
                                
                                
                                            <h4>Subir imagenes</h4>
                                            <div className="dashboard__content-prod">
                                                <div  >
                                                    <FieldArray
                                                        name="imagenes"
                                                        render={(arrayHelpers) => (
                                                            <>
                                                                {/* Para repuestos tradicionales, permitir una sola foto por ahora */}
                                                                {!values.esBaja && (
                                                                    <div className="even-columns">
                                                                        <div>
                                                                        <label htmlFor="foto1">Foto 1</label>
                                                                            <MiUploadArchivo
                                                                                type = 'IMAGEN'
                                                                                idUnique="fotoGeneral1"
                                                                                tipo={TIPO_IMAGEN.FRENTE}
                                                                                setFieldValue={setFieldValue}
                                                                                values={values}
                                                                                arrayHelpers={arrayHelpers}
                                                                            ></MiUploadArchivo>
                                                                        </div>
                                
                                                                        <div>
                                                                            <label htmlFor="foto1">Foto 2</label>
                                                                            <MiUploadArchivo
                                                                                type = 'IMAGEN'
                                                                                idUnique="fotoGeneral2"
                                                                                tipo={TIPO_IMAGEN.ATRAS}
                                                                                setFieldValue={setFieldValue}
                                                                                values={values}
                                                                                arrayHelpers={arrayHelpers}
                                                                            ></MiUploadArchivo>
                                                                        </div>
                                
                                                                        <div>
                                                                            <label htmlFor="foto1">Foto 3</label>
                                                                            <MiUploadArchivo
                                                                                type = 'IMAGEN'
                                                                                idUnique="fotoGeneral3"
                                                                                tipo={TIPO_IMAGEN.CONDUCTOR}
                                                                                setFieldValue={setFieldValue}
                                                                                values={values}
                                                                                arrayHelpers={arrayHelpers}
                                                                            ></MiUploadArchivo>
                                                                        </div>
                                
                                                                        <div>
                                                                            <label htmlFor="foto1">Foto 4</label>
                                                                            <MiUploadArchivo
                                                                                type = 'IMAGEN'
                                                                                idUnique="fotoGeneral4"
                                                                                tipo={TIPO_IMAGEN.ACOMPANIANTE}
                                                                                setFieldValue={setFieldValue}
                                                                                values={values}
                                                                                arrayHelpers={arrayHelpers}
                                                                            ></MiUploadArchivo>
                                                                        </div>
                                                                    </div>
                                                                )}
                                
                                                            </>
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                              <div className="login__socialButtons">
                                                <div className="footer__buttons">
                                                  <button
                                                    className="button"
                                                    type="submit"
                                                    data-type="primary"
                                                    disabled={this.state.grabando}
                                                  >
                                                    Grabar cambios
                                                    <LoadingBoton grabando={this.state.grabando} />
                                                  </button>
                                                </div>
                                              </div>
                                            </Form>
                            )}
                        </Formik>
                        </Modal.Body>
                    </Modal>
            </>
        );
    }
}

function mapState(state) {
    const {} = state;
    return {};
}

const actionCreators = {};

const connectedFormEditarPerfil = connect(mapState, actionCreators)(FormEditarPerfil);
export {connectedFormEditarPerfil as FormEditarPerfil};
